import moment from 'moment'
import { useEffect, useState } from 'react'
import styled from 'styled-components'
import { WhitepaperArticleRecord } from 'types'

import { Container } from '@/components/shared/Container'

const StyledWhitepaperArticleHeader = styled.div`
  padding-left: 100px;
  padding-top: 48px;
  margin-top: 0;
  h1 {
    max-width: 630px;
    font-family: ${(props) => props.theme.v2.font.nantes};
  }
  @media screen and (max-width: ${(props) => props.theme.breakpoints.mobile}) {
    padding-left: 0;
    margin-top: 0;
    h1 {
      max-width: 100%;
    }
  }
`

export const WhitepaperArticleHeader = ({ article }: { article: WhitepaperArticleRecord }) => {
  const publishedDateHeading =
    article._firstPublishedAt?.substring(10) === article._publishedAt?.substring(10) ? 'Published' : 'Updated'
  const [publishDate, setPublishDate] = useState<string>('')

  useEffect(() => {
    setPublishDate(moment(article._publishedAt).format('Do MMMM YYYY'))
  }, [article._publishedAt])

  return (
    <Container>
      <StyledWhitepaperArticleHeader>
        {article._publishedAt && (
          <p className="small">
            {publishedDateHeading} <strong>{publishDate}</strong>
          </p>
        )}
        <h1>{article.articleTitle}</h1>
      </StyledWhitepaperArticleHeader>
    </Container>
  )
}
